var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qrcode"},[_c('img',{attrs:{"src":_vm.qrcode,"alt":""}}),_c('p',{style:(("color:" + _vm.textColor + ";margin:" + _vm.textMargin + "px 0"))},[_vm._v("扫码下载")])])}
var staticRenderFns = []

export { render, staticRenderFns }